export const dictionary = {
  eyeClean : "Eye Clean",
  keyToSymbol: "Key To Symbol",
  hideCertificateNumber: "certificate number",
  hideEstimatedShippingDays: "estimated shipping days",
  secondary: "Secondary parameters",
  shippingDays: "shipping days",
};
